

import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import inputbox from '@/components/ui/inputbox'

import common, { cartHandle } from '@/assets/js/Common'
import api from '@/assets/js/Api'

export default {
name: 'shopCartBox',
directives: {
TransferDom
},
components: { inputbox },
props: {
cartshow: false,
data: {
type: Object,
defalut: ()=>{
return {};
}
}
},
data() {
return {
specData: {},
goodsData: {
store: {}
},
quantity: 0,//购买数量
cartQuantity: 0,    // 购物车存在数据
price: 0,
satisfyReduce: ''
}
},
watch: {
cartshow: function(n,o){


n && this.goodsDetailOperation(this.data);
},
quantity: function(n,o){
this.quantity = Number(n) < 0 ? 0 : Number(n);
this.price = cartHandle.calcPrice(this.specData,this.quantity);
this.satisfyReduce = cartHandle.calcSatisfy(this.specData,this.quantity);
},
},
methods:{


goodsDetailOperation(data){


this.specData = data.spec[0];
this.goodsData = data;
this.price = data.spec[0].price;
this.quantity = 0;  

this.queryCartCount();
},


addCart(handleType){

if(this.specData.stock<1){
return;
}

if(this.quantity===0 && handleType!=='pay'){
this.$vux.toast.text('请指定添加到购物车的数量');
return false;
}

let opts = {
url: api.cartUpdate,
data:{
spec_id: this.specData.spec_id,
quantity: this.quantity,
storeId: common.getCurStoreId()
},
type:'put'
};

common.query(opts).then(res => {



cartHandle.saveCart(this.cartQuantity);

if(handleType==='pay'){
this.$router.push("/cart");
return;
}

this.$vux.toast.text('成功加入到购物车');
this.cartQuantity += this.quantity;
this.quantity = 0;

this.$emit("change",this.cartQuantity);


},res => {
this.$vux.toast.text(res.message);
});
},


changeSpecHandle(item){
this.specData = item;
this.price = cartHandle.calcPrice(item,this.quantity);
this.satisfyReduce = cartHandle.calcSatisfy(item,this.quantity);
},


close(){
this.$emit('close', false)
},


queryCartCount(){

const opts = {
url: api.cartCount,
data: {},
type: 'get'
}
common.query(opts).then(res=>{
const count = Number(res.data)
this.cartQuantity =  count > 0 ? count : 0;
},res=>{})
}
},
mounted(){

}
}



// WEBPACK FOOTER //
// ./src/components/cusShopCart.vue